import React from "react"

import type { Organization } from "@/models/organization"
import { DataGridToolbar } from "@/nzds/data-grid"
import { YearPicker } from "@/nzds/inputs/year-picker"
import type { DateTime, Interval } from "luxon"

import type { GridSlots, PropsFromSlot } from "@mui/x-data-grid-pro"

import { SitesExportCsvMenuItem } from "../../components/sites-export-csv-menu-item"

export interface SitesComplianceGridToolbarProps extends PropsFromSlot<
  GridSlots["toolbar"]
> {
  availableDateRange: Interval | undefined
  dateRange: Interval | undefined
  onYearChange: (value: DateTime) => void
  organizationId?: Organization["id"]
}

export const SitesComplianceGridToolbar: React.FC<
  SitesComplianceGridToolbarProps
> = ({ availableDateRange, dateRange, onYearChange, organizationId }) => {
  return (
    <DataGridToolbar
      moreMenuItems={
        <div>
          {
            // Cannot wrap in fragment (e.g. <></>) due to MUI error
            // https://github.com/mui/material-ui/issues/16181
          }
          <SitesExportCsvMenuItem
            endDate={dateRange?.end?.toISODate()}
            organizationId={organizationId}
            startDate={dateRange?.start?.toISODate()}
          />
        </div>
      }
      showColumnSelector
      startActions={
        <YearPicker
          availableDateRange={availableDateRange}
          onChange={onYearChange}
          value={dateRange?.start}
        />
      }
    />
  )
}
